import type { RechercheDossierQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { buildRechercheStore } from '../storeRechercheBuilder'

export const useRechercheDossierTtStore = buildRechercheStore<RechercheDossierQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDossierTtStore',
  apiPath: '/outilsfpe',
})
